import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class AgentsService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'agents');
  }

  query(text: string): Observable<any> {
    const params = {
      lang: localStorage.getItem('lang') ?? 'en',
      text: text
    }
    if (localStorage.getItem('clientToken') !== null) {
      params['clientToken'] = localStorage.getItem('clientToken');
    }
    if (localStorage.getItem('userId') !== null) {
      params['userId'] = localStorage.getItem('userId');
    }
    return this._http.post(this._baseUrl + '/chatbot_agent/query', params);
  }


}

